import React, { useState } from 'react';
import useDidMountEffect from "../customHooks/useDidMountEffect";
import DeliveryChoice from './DeliveryChoice';
import PaymentSummary from "./PaymentSummary";
import apiCall from "../apiCall";
import PaymentForm from "./PaymentForm";
import { CSSTransition } from 'react-transition-group';
import popupService from '../popup-service';
import PaymentSucceeded from './PaymentSucceeded';
import PropTypes from "prop-types";
import usePaymentRequest from "../customHooks/usePaymentRequest";
import BrowserCardPaymentForm from "./BrowserCardPaymentForm";

const PaymentPage = ({ paymentData }) => {
    const [deliveryChosen, setDeliveryChosen] = useState(paymentData.deliveryChosen ?? false);
    const [changeDeliveryRequestCount, setChangeDeliveryRequestCount] = useState(0);

    const [totalToPayAsBritishCurrency, setTotalToPayAsBritishCurrency] = useState(paymentData.whatBidderOwes.totalToPayAsBritishCurrency);
    const [paymentSucceeded, setPaymentSucceeded] = useState(false);
    const [showPaymentSucceeded, setShowPaymentSucceeded] = useState(false);
   

    const showDelivery = paymentData.includeDelivery && !paymentSucceeded;

    const onDeliveryChoiceMade = wantDelivery => {
        setDeliveryChosen(wantDelivery);
        setChangeDeliveryRequestCount(changeDeliveryRequestCount + 1);
    };

    const onPaymentSucceeded = () => {
        setPaymentSucceeded(true);
        setTimeout(() => setShowPaymentSucceeded(true), 1000);
    };

    const onPaymentFailed = (errorMessage) => {
        popupService.renderErrorMessage(errorMessage);
    };

    const {
        paymentRequestId,
        setNewPaymentRequest,
        paymentRequest
    } = usePaymentRequest(paymentData.clientSecret,
        paymentData.deliveryChosen,
        paymentData.whatBidderOwes.totalToPay,
        `${paymentData.auctionName} total`,
        onPaymentSucceeded, onPaymentFailed);



    useDidMountEffect(() => {
        const onSuccess = async data => {         
            setTotalToPayAsBritishCurrency(data.totalToPayAsBritishCurrency);
            setNewPaymentRequest(data.totalToPay, deliveryChosen, true);
        };

        const onFail = e => {
            apiCall.defaultFail(e);
            setDeliveryChosen(!deliveryChosen);
        };

        const postData = {
            auctionId: paymentData.auctionId,
            bidderId: paymentData.bidderId,
            deliveryRequired: deliveryChosen
        };
        apiCall.post("/api/payment/wantdelivery", postData, onSuccess, onFail);

    }, [changeDeliveryRequestCount]);


    const paymentSucceededProps = {
        isAdmin: paymentData.isAdmin,
        todaysDate: paymentData.todaysDate,
        totalToPay: totalToPayAsBritishCurrency,
        auctionId: paymentData.auctionId
    }


    return (
        <>
            {showDelivery ? (<DeliveryChoice
                deliveryChosen={deliveryChosen}
                onDeliveryChoiceMade={onDeliveryChoiceMade}
            />) : <></>}                    
            <PaymentSummary
                lotsWon={paymentData.whatBidderOwes.lotsWon}
                lotTotal={paymentData.whatBidderOwes.lotsTotalAsBritishCurrency}
                deliveryChosen={deliveryChosen}
                deliveryCharge={paymentData.whatBidderOwes.deliveryChargeAsBritishCurrency}
                amountPledged={paymentData.whatBidderOwes.amountPledgedAsBritishCurrency}
                totalToPay={totalToPayAsBritishCurrency}
            />           
            <CSSTransition
                in={showPaymentSucceeded}
                timeout={400}
                mountOnEnter
                classNames="fade">
                <PaymentSucceeded {...paymentSucceededProps} />
            </CSSTransition>
            {paymentRequest ? <BrowserCardPaymentForm key={paymentRequestId}
                paymentSucceeded={paymentSucceeded}
                paymentRequest={paymentRequest} />
                : null}
            <PaymentForm
                publishableKey={paymentData.publishableKey}
                clientSecret={paymentData.clientSecret}
                showError={onPaymentFailed}
                onSuccess={onPaymentSucceeded}
                customerName={paymentData.bidderName}
                deliveryChosen={deliveryChosen}
                paymentSucceeded={paymentSucceeded}
            />

        </>

    );
};


PaymentPage.propTypes = {
    paymentData: PropTypes.object.isRequired    
}

export default PaymentPage;
